import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import './plugins/element.js'
import ScrollWrap from './components/scroll/index'
import './assets/css/animate.min.css'
import Print from 'vue-print-nb'
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
Vue.use(Print)
Vue.use(ScrollWrap)
Vue.config.productionTip = false

if (process.env.NODE_ENV === "development") {
    window.axios.post('/login/logout', {}).then(() => {
        window.axios.post('/login/process', {user: 'system', password: 'change_on_install'}).then(res => {
            store.commit('setState', {key: 'student', value: res.student})
        })
    })
    
}

Date.prototype.$Format = function (fmt, American) { //author: meizz
    if (American === true) {
        new RegExp(/(.+)\sGMT/).exec(this)
        return RegExp.$1
    }
    let o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
Date.prototype.$getWeek = function () {
    var days = this.getDay();
    switch (days) {
        case 1:
            days = '星期一';
            break;
        case 2:
            days = '星期二';
            break;
        case 3:
            days = '星期三';
            break;
        case 4:
            days = '星期四';
            break;
        case 5:
            days = '星期五';
            break;
        case 6:
            days = '星期六';
            break;
        case 0:
            days = '星期日';
            break;
    }
    return days
}

new Vue({
    router,
    store,
    render: h => h(App)
    
}).$mount('#app')
